<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card" :body-style="{ padding: '8px' }">
            <el-page-header content="用户列表" :icon="null" title="用户管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">刷新</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                    <el-button @click="handleExport()">
                        导出
                        <el-icon class="el-icon--right">
                            <Download />
                        </el-icon>
                    </el-button>
                </template>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%;margin-top: 8px;" height="calc(100vh - 193px)"
                row-key="id" v-loading="state.tableLoading">
                <el-table-column prop="phone" label="手机号码" min-width="120px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.phone }">
                            <span>手机号码</span>
                            <el-icon ref="triggerRefPhone">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="userNature " label="用户标签" min-width="120px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.userNature }">
                            <span>用户标签</span>
                            <el-icon ref="triggerRefUserNature">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                    <template #default="scope">
                        {{ filterUserNature(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column prop="company " label="企业名称" min-width="200px">
                    <template #default="scope">
                        {{ scope.row?.company || '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="recommenderPhone" label="推荐人手机号" min-width="140px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.recommenderPhone }">
                            <span>推荐人手机号</span>
                            <el-icon ref="triggerRefRecommenderPhone">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="用户类型" min-width="120px">
                    <template #default="scope">
                        {{ statusMap[scope.row.type] }}
                    </template>
                </el-table-column>
                <el-table-column prop="memberType" label="会员类型" min-width="100px" />
                <el-table-column prop="latestOperTime" label="最后操作时间" min-width="180px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.daterange }">
                            <span>最后操作时间</span>
                            <el-icon @click="dateRangeFilter" ref="triggerRefDaterange">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                    <template #default="scope">
                        {{ scope.row.memberStartTime || '--' }}
                    </template>
                </el-table-column>
                <el-table-column prop="memberStartTime" label="会员开始时间" min-width="180px">
                    <template #default="scope">
                        {{ scope.row.memberStartTime || '--' }}
                    </template>
                </el-table-column>
                <el-table-column prop="memberEndTime" label="会员到期时间" min-width="180px">
                    <template #default="scope">
                        {{ scope.row.memberEndTime || '--' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="注册时间" min-width="180px" />
                <el-table-column fixed="right" label="操作" width="140px">
                    <template #default="scope">
                        <el-button type="primary" @click="handleEdit(scope.row)" size="small">编辑</el-button>
                        <el-popconfirm title="是否要删除当前数据?" confirm-button-text="是" cancel-button-text="否"
                            @confirm="handleDelete(scope.row)">
                            <template #reference>
                                <el-button type="danger" size="small">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
    <el-dialog v-model="state.dialogVisible" title="编辑用户" width="40%">
        <el-form ref="userFormRef" :model="state.formValue" :rules="state.formRules" label-width="80px" status-icon>
            <el-form-item label="用户名" prop="userName">
                <el-input v-model="state.formValue.userName" placeholder="请输入用户名" />
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="state.formValue.phone" type="number" placeholder="请输入手机号" disabled />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input v-model="state.formValue.email" type="text" placeholder="请输入邮箱" />
            </el-form-item>
            <el-form-item label="推荐人ID" prop="recommenderId">
                <el-input v-model="state.formValue.recommenderId" type="text" placeholder="请输入推荐人ID" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="state.dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="dialogConfirm">确认</el-button>
            </span>
        </template>
    </el-dialog>
    <!-- 筛选popover -->
    <FilterPhone @handleSearch="handleSearch" :triggerRef="triggerRefPhone" field="phone" :formValue="search" />
    <FilterSelect @handleSearch="handleSearch" :triggerRef="triggerRefUserNature" field="userNature" :formValue="search"
        :options="state.options" placeholder="请选用户标签" />
    <FilterPhone @handleSearch="handleSearch" :triggerRef="triggerRefRecommenderPhone" field="recommenderPhone"
        :formValue="search" />
    <FilterDateRange ref="popoverRefDaterange" :triggerRef="triggerRefDaterange" @handleSearch="handleSearch"
        field="daterange" :formValue="search" />
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { Download, Filter } from '@element-plus/icons-vue'
import { getUserListFun, deleteFun, getDetailFun, editFun, exportFun } from "@/api/user"
import { phoneValidator, emailValidator } from "@/util/formValidator";
import { cloneDeep } from 'lodash-es';
import FilterPhone from '@/components/TableFilter/FilterPhone.vue'
import FilterSelect from '@/components/TableFilter/FilterSelect.vue'
import FilterDateRange from '@/components/TableFilter/FilterDateRange.vue'

const triggerRefPhone = ref();// 手机号筛选ref
const triggerRefUserNature = ref();// 用户标签筛选ref
const triggerRefRecommenderPhone = ref();// 推荐人手机号筛选ref
const triggerRefDaterange = ref();// 操作时间筛选
const popoverRefDaterange = ref();// 操作时间筛选

const search = reactive({
    phone: "",
    userNature: '',
    recommenderPhone: "",
    daterange: '',
})
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    dialogVisible: false,
    formValue: {
        userName: '',
        phone: '',
        email: '',
        recommenderId: '',
        id: null
    },
    formRules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        phone: [{ required: true, validator: phoneValidator, trigger: 'blur' }],
        email: [{ validator: emailValidator, trigger: 'blur' }],
    },
    options: [
        { label: "未充值用户", value: 0 },
        { label: "内部用户", value: 1 },
    ],});
const tableData = ref([]);
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});

const statusMap = {
    1: "微信小程序",
    2: "抖音小程序",
    3: "后台管理系统",
};
const userFormRef = ref();
// 行操作 编辑
const handleEdit = (row) => {
    state.fullLoading = true;
    getDetailFun(row.id).then((res) => {
        if (res.data) {
            state.formValue.userName = res.data.userName;
            state.formValue.phone = res.data.phone;
            state.formValue.email = res.data.email ?? '';
            state.formValue.recommenderId = res.data.recommenderId ?? '';
            state.formValue.id = res.data.id;
            state.dialogVisible = true;
        }
    }).finally(() => {
        state.fullLoading = false;
    })
}
// 行操作 删除
const handleDelete = (row) => {
    state.tableLoading = true;
    deleteFun(row.id).then((res) => {
        pagination.current = 1;
        pagination.size = 10;
        intTableData();
    }).finally(() => {
        state.tableLoading = false;
    });
}
const handleExport = () => {
    state.fullLoading = true;
    exportFun().finally(() => {
        state.fullLoading = false;
    })
}
// 时间日期筛选点击
const dateRangeFilter = () => {
    popoverRefDaterange.value.state.visible = !popoverRefDaterange.value.state.visible;
}
// 列表查询
const handleSearch = () => {
    searchFun(1);
}
// 查询 1查询 2重置
const searchFun = (type) => {
    popoverRefDaterange.value.state.visible = false;
    if (type == 2) {
        search.userNature = '';
        search.userName = '';
        search.phone = '';
        search.recommenderPhone = '';
        search.daterange = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.fullLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }
    const searchValue = cloneDeep(search);
    for (let key in searchValue) {
        if (searchValue[key]) {
            if (key == 'daterange') {
                params.formValue['latestOperTimeStart'] = searchValue[key][0];
                params.formValue['latestOperTimeEnd'] = searchValue[key][1];
                params.keys.push('latestOperTimeStart');
                params.keys.push('latestOperTimeEnd');
            } else {
                params.keys.push(key);
                params.formValue[key] = searchValue[key];
            }
        }
    }
    getUserListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
    }).finally(() => {
        state.fullLoading = false;
    });
}
// 编辑确认
const dialogConfirm = () => {
    // 1.校验表单
    userFormRef.value.validate((valid) => {
        if (valid) {
            state.fullLoading = true;
            const params = {
                userName: state.formValue.userName,
                email: state.formValue.email,
                recommenderId: state.formValue.recommenderId,
                id: state.formValue.id,
            }
            editFun(params).then((res) => {
                state.dialogVisible = false;
                intTableData();
            }).finally(() => {
                state.fullLoading = false;
            });
        }
    })
}
// 编辑确认
const filterUserNature = (row) => {
    const userNature = row?.userNature;
    if (userNature === undefined || userNature === null || userNature === '') {
        return '';
    }
    const node = state.options.find((item) => item.value == userNature);
    return node?.label || '--';
}
onMounted(() => {
    intTableData();
});
</script>
<style lang="scss" scoped>
:deep .el-card {
    box-shadow: none!important;
    border-radius: inherit;
    border: none;
}

.pagination-box {
    text-align: right;
}

.el-pagination {
    margin-top: 8px;
    float: right;
}

.header-cell {
    width: 100%;
    position: relative;

    :deep .el-icon {
        position: absolute;
        right: 0;
        font-size: 16px;
        line-height: 23px;
        font-weight: bold;
        display: inline-block;
        cursor: pointer;
        transition: all 0.2s;

        svg {
            height: 23px;
        }
    }

    :deep .el-icon:hover {
        color: #409eff;
    }
}

.header-cell_active {
    :deep .el-icon {
        color: #409eff;
    }
}
</style>